<template>
    <div>
        <div v-if="text && text.length > 0">
            <div v-if="text.length >= 2">
                <div>
                    <span>
                        <el-tag :type="getSignColor(text[0], 'tagType')"
                            :style="{ color: getSignColor(text[0], 'color'), 'background-color': getSignColor(text[0], 'backgroundColor'), 'margin-bottom': '10px' }"><i
                                :class="getSignColor(text[0], 'icon')"></i>
                            {{ getSignColor(text[0], 'name') }}</el-tag>
                        <el-tooltip content="折叠" v-if="showToolTip[index]">
                            <i class="el-icon-caret-top iconMore" @click="openMore(index)"></i>
                        </el-tooltip>
                        <el-tooltip content="展开" v-if="!showToolTip[index]">
                            <i class="el-icon-caret-bottom iconMore" @click="openMore(index)"></i>
                        </el-tooltip>
                    </span>
                    <div v-for="(status, index1) in text" :key="index1" v-if="showToolTip[index]">
                        <el-tag :type="getSignColor(status, 'tagType')"
                            :style="{ color: getSignColor(status, 'color'), 'background-color': getSignColor(status, 'backgroundColor'),'margin-bottom':'10px' }"><i
                                :class="getSignColor(status, 'icon')"></i>
                            {{ getSignColor(status, 'name') }}</el-tag>
                    </div>
                </div>
            </div>
            <div v-else>
                <el-tag :type="getSignColor(text[0], 'tagType')"
                    :style="{ color: getSignColor(text[0], 'color'), 'background-color': getSignColor(text[0], 'backgroundColor') }"><i
                        :class="getSignColor(text[0], 'icon')"></i>
                    {{ getSignColor(text[0], 'name') }}</el-tag>
            </div>
        </div>
        <div v-else>
            <el-tag  type="info"><i class="fas fa-circle-notch status-icon"></i>未申请</el-tag>
        </div>
    </div>
</template>

<script>

import { getSignColor } from "@/color"

export default {
    name: "ExFoldSign",
    props: {
        text: {
            default: () => ([])
        },
        index: {
            default: 0
        },
    },
    data() {
        return {
            showToolTip: [],
        }
    },
    methods: {
        getSignColor,
        openMore(index) {
            this.$set(this.showToolTip, index, !this.showToolTip[index]);
        }
    }
}
</script>

<style scoped>
.iconMore {
    color: #4eaad4;
    cursor: pointer;
}

.flex-container {
    display: flex;
    align-items: center;
    /* 垂直居中对齐 */
    max-width: 600px;
    /* 根据需要调整最大宽度 */
    margin: 0 auto;
    /* 居中整个容器 */
}

.name-right {
    text-align: right;
    /* 右对齐名称部分 */
    min-width: 100px;
    /* 最小宽度，防止名称过短时布局错乱 */
    max-width: 200px;
    /* 最大宽度，防止名称过长时占据过多空间 */
    margin-right: 10px;
    /* 可选：添加右侧间距 */
}
</style>
  
